import React, { Fragment, useState } from 'react'
import Img1 from "../images/avatar.png"
import { toast } from 'react-toastify'
import { updateAvatarAction } from '../../redux/actions/userActions'
import { useDispatch } from 'react-redux'
import { uploadToCloudinary } from '../../utils/uploadToCloudinary'
import store from "../../store"


const UpateAvatar = ({ hideSection, avatar_url }) => {




    const dispatch = useDispatch()



    const [profileImage, setProfileImage] = useState()
    const [profileImagePreview, setProfileImagePreview] = useState()


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            setProfileImage(file);
            setProfileImagePreview(URL.createObjectURL(file));
        } else {
            alert("Only PNG and JPG files are allowed!");
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            setProfileImage(file);
            setProfileImagePreview(URL.createObjectURL(file));
        } else {
            alert("Only PNG and JPG files are allowed!");
        }
    };

    const handleDragOver = (e) => e.preventDefault();





    const handleSubmit = async () => {

        if (!profileImage) {
            toast.error('Please Upload New avatar to change');
            return;
        }

        try {
            // ✅ START (add this)
            store.dispatch({ type: "UPLOAD_START" });

            // 1️⃣ Upload image
            const profileImageURL = await uploadToCloudinary(
                profileImage,
                "avatars",
                1, // current
                1  // total
            );

            // 2️⃣ Send to backend
            const data = {
                newAvatar: profileImageURL,
            };

            await dispatch(updateAvatarAction(data));

            // ✅ END (add this)
            store.dispatch({ type: "UPLOAD_END" });

        } catch (err) {
            store.dispatch({ type: "UPLOAD_RESET" });

            toast.error("Image upload failed. Please Check your Internet Connection and then try again.");
        }
    };






    return (
        <Fragment>

            <section className='flex-center fixed top-0 left-0 min-h-[100vh] bg-[#000000c4] w-[100%] z-[999]' >
                <div className="w-[40%] bg-white p-[1.5vmax] shadow-1 rounded-[1vmax] relative">
                    <button
                        onClick={() => hideSection()}
                        className='absolute top-[0.5vmax] right-[1.5vmax] text-[2vmax]' ><i className="fa-solid fa-xmark"></i></button>
                    <h3 className='font-bold' >Update Profile Image</h3>
                    <div className="flex justify-between mt-[1vmax]">
                        {/* Left side preview box */}
                        <div className="w-[20%]  flex-center aspect-[2/2.5] overflow-hidden h-fit]">
                            <img
                                src={profileImagePreview || avatar_url || Img1}
                                alt="Preview"
                                className="w-[6vmax] h-[6vmax] rounded-[50%] object-contain"
                            />
                        </div>

                        {/* Right side upload area */}
                        <div className="w-[75%]">
                            <div
                                className="w-[100%] bg-gray-100 border-[0.2vmax] border-dashed border-gray-400 rounded-[2vmax] flex-center cursor-pointer hover:bg-gray-50 transition-all duration-200 py-[1vmax] mt-[1vmax]"
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                                onClick={() => document.getElementById("fileInput").click()}
                            >
                                <input
                                    id="fileInput"
                                    type="file"
                                    accept="image/png, image/jpeg"
                                    onChange={handleFileChange}
                                    className="hidden"
                                />
                                <p className="text-center leading-[2vmax] text-gray-600">
                                    <strong>Drag & Drop</strong> your image here, or{" "}
                                    <strong>click to upload</strong>.<br />

                                    Only <strong>PNG</strong> and <strong>JPG</strong> formats are supported.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="text-center ">
                        <button className={`font-bold text-white  py-[0.8vmax] rounded-[2vmax] px-[1.5vmax] hover:scale-[0.9] ${profileImage ? 'bg-[image:var(--gradient-2)]' : 'bg-gray-400 cursor-not-allowed'}`}
                            disabled={profileImage ? false : true}
                            onClick={() => handleSubmit()}
                        >Set Profile Image</button>
                    </div>

                </div>
            </section>
        </Fragment>
    )
}

export default UpateAvatar